import { render, staticRenderFns } from "./ProfissionalUserForm.vue?vue&type=template&id=23015e4c"
import script from "./ProfissionalUserForm.vue?vue&type=script&lang=js"
export * from "./ProfissionalUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports